import { useRegisterSW } from "virtual:pwa-register/react";

/**
 * Registra o service worker e avisa quando há versão nova. A atualização só acontece quando a pessoa confirma,
 * para nunca recarregar a página no meio de uma vistoria.
 */
export function UpdatePrompt() {
  const { needRefresh: [needRefresh, setNeedRefresh], offlineReady: [offlineReady, setOfflineReady], updateServiceWorker } = useRegisterSW({
    onRegisterError(error) { console.warn("Service worker não registrado:", error); }
  });
  if (!needRefresh && !offlineReady) return null;
  return <div className="update-prompt" role="status" aria-live="polite">
    {needRefresh
      ? <><span><strong>Nova versão disponível.</strong> Termine o que está fazendo e atualize.</span><button type="button" className="button primary" onClick={() => void updateServiceWorker(true)}>Atualizar agora</button><button type="button" className="button ghost" onClick={() => setNeedRefresh(false)}>Depois</button></>
      : <><span><strong>Pronto para uso sem internet.</strong> O aplicativo foi guardado neste aparelho.</span><button type="button" className="button ghost" onClick={() => setOfflineReady(false)}>Ok</button></>}
  </div>;
}
